import styled from "styled-components";

export const Page = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.lightBlue};
`;

export const HeaderArea = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
`;

export const Content = styled.main`
  width: min(680px, calc(100% - 32px));
  min-height: 520px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing(10)} 0
    ${({ theme }) => theme.spacing(16)};
`;

export const Card = styled.section`
  padding: ${({ theme }) => theme.spacing(7)};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.light.small};
  display: grid;
  gap: ${({ theme }) => theme.spacing(5)};
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: ${({ theme }) => theme.fontSizes.xl};
`;

export const Warning = styled.p`
  padding: ${({ theme }) => theme.spacing(4)};
  border: 1px solid ${({ theme }) => theme.colors.lightRed};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: #fff7f6;
  color: ${({ theme }) => theme.colors.mediumGray};
  line-height: 1.5;
`;

export const Field = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.mediumGray};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;

export const Input = styled.input`
  width: 100%;
  min-height: 48px;
  padding: 0 ${({ theme }) => theme.spacing(3)};
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  color: ${({ theme }) => theme.colors.mediumGray};
  font: inherit;

  &:focus {
    border-color: ${({ theme }) => theme.colors.red};
    outline: 2px solid ${({ theme }) => theme.colors.lightRed};
  }
`;

export const DeleteButton = styled.button`
  width: fit-content;
  min-height: 48px;
  padding: 0 ${({ theme }) => theme.spacing(5)};
  border: 1px solid ${({ theme }) => theme.colors.red};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ theme }) => theme.colors.red};
  color: ${({ theme }) => theme.colors.white};
  font: inherit;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  cursor: pointer;

  &:disabled {
    border-color: ${({ theme }) => theme.colors.gray};
    background: ${({ theme }) => theme.colors.lightGray};
    color: ${({ theme }) => theme.colors.disabledGray};
    cursor: not-allowed;
  }
`;
